import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/Layout';
import { ApiProvider } from './Context/ApiContext';
import './custom.css'
import { CookiesProvider } from 'react-cookie';
import {ThemeProvider} from './Context/ThemeContext';


export default function App() {
  // Configurações de cookie para persistência de sessão
  const cookieOptions = {
    path: '/',
    maxAge: 60 * 60 * 24 * 30, // 30 dias em segundos
    sameSite: 'lax',
    secure: false, // Mude para true em produção com HTTPS
    httpOnly: false // Deve ser false para permitir acesso via JavaScript
  };

  return (
    <ApiProvider>
      <CookiesProvider defaultSetOptions={cookieOptions}>
        <ThemeProvider>
          <Layout>
            <Routes>
              {AppRoutes.map((route, index) => {
                const { element, ...rest } = route;
                return <Route key={index} {...rest} element={element} />;
              })}
            </Routes>
          </Layout>
          </ThemeProvider>
      </CookiesProvider>
    </ApiProvider>
  );
}
